(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[656],{

/***/ 7608:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo",
      function () {
        return __webpack_require__(4731);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1770);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

var customerLogos = {
    block: {
        name: "Block",
        src: "/img/customers/customer-block.png",
        scale: 1.125,
        href: "https://block.xyz/"
    },
    shopify: {
        name: "Shopify",
        src: "/img/customers/customer-shopify.svg",
        scale: 1,
        href: "https://www.shopify.com/"
    },
    airbnb: {
        name: "Airbnb",
        src: "/img/customers/customer-airbnb.svg",
        scale: 1.1,
        href: "https://airbnb.com/"
    },
    sweetgreen: {
        name: "sweetgreen",
        src: "/img/customers/customer-sweetgreen.svg",
        scale: 0.875,
        href: "https://www.sweetgreen.com/"
    },
    figma: {
        name: "Figma",
        src: "/img/customers/customer-figma.svg",
        scale: 0.75,
        href: "https://figma.com/"
    },
    everlane: {
        name: "Everlane",
        src: "/img/customers/customer-everlane.svg",
        scale: 0.85,
        href: "https://everlane.com/"
    },
    stripe: {
        name: "Stripe",
        src: "/img/customers/customer-stripe.svg",
        scale: 1.1,
        href: "https://stripe.com/"
    },
    imperfect: {
        name: "Imperfect Foods",
        src: "/img/customers/customer-imperfect.png",
        scale: 1.75,
        href: "https://www.imperfectfoods.com/"
    },
    warby: {
        name: "Warby Parker",
        src: "/img/customers/customer-warby.svg",
        scale: 1.0625,
        href: "https://www.warbyparker.com/"
    },
    vimeo: {
        name: "Vimeo",
        src: "/img/customers/customer-vimeo.svg",
        scale: 1,
        href: "https://vimeo.com/"
    },
    expensify: {
        name: "Expensify",
        src: "/img/customers/customer-expensify.svg",
        scale: 0.9,
        href: "https://expensify.com/"
    },
    doordash: {
        name: "DoorDash",
        src: "/img/customers/customer-doordash.svg",
        scale: 0.9,
        href: "https://doordash.com/"
    },
    klarna: {
        name: "Klarna",
        src: "/img/customers/customer-klarna.svg",
        scale: 0.7,
        href: "https://klarna.com/"
    },
    twitter: {
        name: "Twitter",
        src: "/img/customers/customer-twitter.svg",
        scale: 1,
        href: "https://twitter.com/"
    },
    wise: {
        name: "Wise",
        src: "/img/customers/customer-wise.svg",
        scale: 0.7,
        href: "https://wise.com/"
    },
    mongodb: {
        name: "MongoDB",
        src: "/img/customers/customer-mongodb.svg",
        scale: 1.3,
        href: "https://www.youtube.com/watch?v=CeFP3Gm7aGc"
    },
    servicenow: {
        name: "ServiceNow",
        src: "/img/customers/customer-servicenow.svg",
        scale: 0.875,
        href: "https://servicenow.com/"
    },
    flexport: {
        name: "Flexport",
        src: "/img/customers/customer-flexport.png",
        scale: 0.8,
        href: "https://flexport.com/"
    },
    monzo: {
        name: "Monzo",
        src: "/img/customers/customer-monzo.svg",
        scale: 2.1,
        href: "https://monzo.com/"
    },
    zynga: {
        name: "Zynga",
        src: "/img/customers/customer-zynga.svg",
        scale: 0.8,
        href: "https://zynga.com/"
    },
    ziprecruiter: {
        name: "ZipRecruiter",
        src: "/img/customers/customer-ziprecruiter.svg",
        scale: 1.15,
        href: "https://ziprecruiter.com/"
    },
    revolut: {
        name: "Revolut",
        src: "/img/customers/customer-revolut.svg",
        scale: 0.7,
        href: "https://revolut.com/"
    },
    calm: {
        name: "Calm",
        src: "/img/customers/customer-calm.png",
        scale: 1,
        href: "https://www.calm.com/"
    },
    boom: {
        name: "Boom",
        src: "/img/customers/customer-boom.png",
        scale: 1,
        href: "https://boomsupersonic.com/"
    },
    samsara: {
        name: "Samsara",
        src: "/img/customers/customer-samsara.svg",
        scale: 0.95,
        href: "https://samsara.com/"
    },
    zendesk: {
        name: "Zendesk",
        src: "/img/customers/customer-zendesk.svg",
        scale: 0.66,
        href: "https://zendesk.com/"
    },
    meundies: {
        name: "MeUndies",
        src: "/img/customers/customer-meundies.svg",
        scale: 0.75,
        href: "https://meundies.com/"
    },
    dataiku: {
        name: "Dataiku",
        src: "/img/customers/customer-dataiku.svg",
        scale: 1.25,
        href: "https://www.dataiku.com/"
    },
    misfits: {
        name: "Misfits Market",
        src: "/img/customers/customer-misfits.svg",
        scale: 0.95,
        href: "https://www.misfitsmarket.com/"
    },
    pressed: {
        name: "Pressed Juicery",
        src: "/img/customers/customer-pressed.svg",
        scale: 0.85,
        href: "https://pressed.com/"
    },
    sonder: {
        name: "Sonder",
        src: "/img/customers/customer-sonder.svg",
        scale: 1,
        href: "https://sonder.com/"
    },
    segment: {
        name: "Segment",
        src: "/img/customers/customer-segment.svg",
        scale: 0.9,
        href: "https://segment.io/"
    },
    newrelic: {
        name: "New Relic",
        src: "/img/customers/customer-newrelic.svg",
        scale: 0.85,
        href: "https://newrelic.com/"
    },
    eventbrite: {
        name: "Eventbrite",
        src: "/img/customers/customer-eventbrite.svg",
        scale: 0.75,
        href: "https://eventbrite.com/"
    },
    spotify: {
        name: "Spotify",
        src: "/img/customers/customer-spotify.svg",
        scale: 1.2,
        href: "https://spotify.com/"
    },
    hopin: {
        name: "Hopin",
        src: "/img/customers/customer-hopin.svg",
        scale: 0.95,
        href: "https://hopin.com/"
    },
    yelp: {
        name: "Yelp",
        src: "/img/customers/customer-yelp.svg",
        scale: 1.5,
        href: "https://yelp.com/"
    },
    coupa: {
        name: "Coupa",
        src: "/img/customers/customer-coupa.svg",
        scale: 1,
        href: "https://coupa.com/"
    },
    ebanx: {
        name: "Ebanx",
        src: "/img/customers/customer-ebanx.svg",
        scale: 0.7,
        href: "https://ebanx.com/"
    },
    datadog: {
        name: "Datadog",
        src: "/img/customers/customer-datadog.svg",
        scale: 1.25,
        href: "https://datadog.com/"
    },
    digitalocean: {
        name: "DigitalOcean",
        src: "/img/customers/customer-digitalocean.svg",
        scale: 1,
        href: "https://digitalocean.com/"
    },
    okta: {
        name: "Okta",
        src: "/img/customers/customer-okta.svg",
        scale: 0.75,
        href: "https://okta.com/"
    },
    onfido: {
        name: "Onfido",
        src: "/img/customers/customer-onfido.svg",
        scale: 0.875,
        href: "https://onfido.com/"
    },
    pinterest: {
        name: "Pinterest",
        src: "/img/customers/customer-pinterest.svg",
        scale: 1.125,
        href: "https://pinterest.com/"
    },
    workos: {
        name: "WorkOS",
        src: "/img/customers/customer-workos.svg",
        scale: 0.8,
        href: "https://workos.com/"
    },
    kainos: {
        name: "Kainos",
        src: "/img/customers/customer-kainos.png",
        scale: 0.75,
        href: "https://kainos.com"
    },
    taskus: {
        name: "TaskUs",
        src: "/img/customers/customer-taskus.png",
        scale: 0.875,
        href: "https://taskus.com"
    },
    verkada: {
        name: "Verkada",
        src: "/img/customers/customer-verkada.svg",
        scale: 0.75,
        href: "https://verkada.com"
    },
    squareRoots: {
        name: "Square Roots",
        src: "/img/customers/customer-squareRoots.svg",
        scale: 0.85,
        href: "https://www.squarerootsgrow.com/"
    },
    dailyHarvest: {
        name: "Daily Harvest",
        src: "/img/customers/customer-dailyHarvest.svg",
        scale: 1,
        href: "https://www.daily-harvest.com/"
    },
    zuora: {
        name: "Zuora",
        src: "/img/customers/customer-zuora.svg",
        scale: 0.55,
        href: "https://zuora.com/"
    },
    walmart: {
        name: "Walmart",
        src: "/img/customers/customer-walmart.svg",
        scale: 1,
        href: "https://walmart.com"
    },
    generalAtlantic: {
        name: "General Atlantic",
        src: "/img/customers/customer-generalAtlantic.svg",
        scale: 0.9,
        href: "https://www.generalatlantic.com/"
    },
    atomico: {
        name: "Atomico",
        src: "/img/customers/customer-atomico.svg",
        scale: 0.75,
        href: "https://www.atomico.com/"
    },
    tiger: {
        name: "Tiger Global",
        src: "/img/customers/customer-tiger.svg",
        scale: 1,
        href: "https://www.tigerglobal.com/"
    },
    fortress: {
        name: "Fortress Investment Group",
        src: "/img/customers/customer-fortress.svg",
        scale: 0.9,
        href: "https://www.fortress.com"
    },
    generalCatalyst: {
        name: "General Catalyst",
        src: "/img/customers/customer-generalCatalyst.svg",
        scale: 1,
        href: "https://www.generalcatalyst.com/"
    }
};
function getCustomers(keys) {
    return keys.trim().split(/\s+/).map(function(key) {
        return customerLogos[key];
    });
}
var customerSets = {
    "en-US": {
        home: "\n    block shopify airbnb sweetgreen twitter everlane\n    stripe warby imperfect spotify doordash expensify\n    klarna digitalocean servicenow pinterest flexport wise\n    ",
        // block shopify doordash klarna kainos taskus
        customers: "\n    airbnb stripe everlane pinterest warby expensify\n    vimeo twitter eventbrite wise digitalocean imperfect \n    servicenow flexport spotify mongodb zendesk ziprecruiter \n    calm boom newrelic sonder hopin misfits\n    monzo okta meundies segment figma revolut\n    workos datadog zynga pressed ebanx dataiku\n    ",
        // onfido verkada squareRoots coupa dailyHarvest zuora
        demo: "\n    block shopify airbnb\n    sweetgreen everlane zynga\n    stripe imperfect twitter\n    expensify doordash pinterest\n    warby wise flexport\n    spotify mongodb klarna\n    sonder segment vimeo\n    calm servicenow zendesk\n    ",
        finance: "generalAtlantic atomico tiger fortress generalCatalyst"
    },
    "en-GB": {
        home: "\n    shopify atomico airbnb klarna wise onfido\n    stripe monzo spotify revolut okta vimeo\n    dataiku twitter hopin servicenow pinterest verkada\n    ",
        customers: "\n    airbnb klarna wise hopin spotify monzo\n    revolut twitter stripe dataiku atomico block\n    vimeo okta verkada onfido flexport servicenow\n    meundies digitalocean zendesk pinterest calm expensify\n    imperfect segment newrelic ebanx figma ziprecruiter\n    sonder doordash everlane boom warby zynga\n    ",
        demo: "\n    monzo shopify airbnb\n    hopin block klarna\n    onfido okta revolut \n    stripe verkada spotify\n    wise mongodb twitter\n    servicenow flexport dataiku\n    vimeo segment expensify\n    doordash zendesk pinterest\n    ",
        finance: "generalAtlantic atomico tiger fortress generalCatalyst"
    }
};
function useCustomerSet(area) {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().locale;
    return getCustomers(customerSets[locale][area]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useCustomerSet);


/***/ }),

/***/ 4731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1614);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9496);
/* harmony import */ var next_localization__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(351);
/* harmony import */ var _components_meta__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1797);
/* harmony import */ var _components_navbar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9106);
/* harmony import */ var _components_customer_logos__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7118);
/* harmony import */ var _components_footer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4898);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1770);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);











function Demo() {
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)().asPath;
    var t = (0,next_localization__WEBPACK_IMPORTED_MODULE_5__/* .useI18n */ .QT)().t;
    var customers = (0,_components_customer_logos__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("demo");
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), sendState = ref[0], setSendState = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (asPath.endsWith("thanks")) {
            setSendState("sent");
            return;
        }
    }, [
        asPath
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: "Request a demo"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navbar__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "jsx-b8a2230a7dc7ead2" + " " + "grid",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-b8a2230a7dc7ead2" + " " + "left-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "jsx-b8a2230a7dc7ead2",
                                children: "Request a demo"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "jsx-b8a2230a7dc7ead2" + " " + "intro",
                                children: [
                                    "We\u2019re excited to show you how Watershed can help you launch and run your company\u2019s climate ",
                                    t("common.program"),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                style: {
                                    marginTop: 48,
                                    marginBottom: 24,
                                    fontSize: 24
                                },
                                className: "jsx-b8a2230a7dc7ead2",
                                children: "Trusted by"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    width: "80%"
                                },
                                className: "jsx-b8a2230a7dc7ead2" + " " + "customer-logos",
                                children: [
                                    customers.map(function(customer) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            alt: customer.name,
                                            draggable: "false",
                                            src: customer.src,
                                            width: 128,
                                            height: 28,
                                            objectFit: "contain",
                                            objectPosition: "left center"
                                        }, customer.name);
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                                        dangerouslySetInnerHTML: {
                                            __html: customers.map(function(param, i) {
                                                var scale = param.scale;
                                                return scale === 1 ? undefined : ".customer-logos > span:nth-child(".concat(i + 1, ") img { transform: scale(").concat(scale, "); }");
                                            }).filter(Boolean).join("\n")
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-b8a2230a7dc7ead2" + " " + "right-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "jsx-b8a2230a7dc7ead2" + " " + "mobile-title",
                                children: "Request a demo"
                            }),
                            sendState === "sent" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    padding: 24
                                },
                                className: "jsx-b8a2230a7dc7ead2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-b8a2230a7dc7ead2",
                                        children: "Thank you! We\u2019ll email you back soon."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: function() {
                                            return setSendState(null);
                                        },
                                        className: "jsx-b8a2230a7dc7ead2",
                                        children: "Submit another request"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                action: "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8",
                                method: "POST",
                                className: "jsx-b8a2230a7dc7ead2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        type: "hidden",
                                        name: "oid",
                                        value: "00D8b000001aSkL",
                                        className: "jsx-b8a2230a7dc7ead2"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        type: "hidden",
                                        name: "retURL",
                                        value: "https://watershed.com/demo/thanks",
                                        className: "jsx-b8a2230a7dc7ead2"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        id: "lead_source",
                                        name: "lead_source",
                                        type: "hidden",
                                        value: "Inbound: Demo Request",
                                        className: "jsx-b8a2230a7dc7ead2"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        id: "rating",
                                        name: "rating",
                                        type: "hidden",
                                        value: "Hot",
                                        className: "jsx-b8a2230a7dc7ead2"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                        className: "jsx-b8a2230a7dc7ead2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-b8a2230a7dc7ead2" + " " + "title required",
                                                children: "First name"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                autoFocus: true,
                                                type: "text",
                                                name: "first_name",
                                                placeholder: "Jane",
                                                autoComplete: "given-name",
                                                required: true,
                                                maxLength: 40,
                                                className: "jsx-b8a2230a7dc7ead2"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                        className: "jsx-b8a2230a7dc7ead2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-b8a2230a7dc7ead2" + " " + "title required",
                                                children: "Last name"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "text",
                                                name: "last_name",
                                                placeholder: "Smith",
                                                autoComplete: "family-name",
                                                required: true,
                                                maxLength: 80,
                                                className: "jsx-b8a2230a7dc7ead2"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                        className: "jsx-b8a2230a7dc7ead2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-b8a2230a7dc7ead2" + " " + "title required",
                                                children: "Company name"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "text",
                                                name: "company",
                                                placeholder: "My Company",
                                                required: true,
                                                maxLength: 40,
                                                className: "jsx-b8a2230a7dc7ead2"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                        className: "jsx-b8a2230a7dc7ead2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-b8a2230a7dc7ead2" + " " + "title required",
                                                children: "Work email"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "email",
                                                name: "email",
                                                placeholder: "jsmith@company.com",
                                                autoComplete: "email",
                                                required: true,
                                                maxLength: 80,
                                                className: "jsx-b8a2230a7dc7ead2"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                        className: "jsx-b8a2230a7dc7ead2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-b8a2230a7dc7ead2" + " " + "title",
                                                children: "Phone number"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "tel",
                                                name: "phone",
                                                placeholder: "(555) 555-5555",
                                                autoComplete: "tel",
                                                maxLength: 40,
                                                className: "jsx-b8a2230a7dc7ead2"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        style: {
                                            marginTop: -12
                                        },
                                        className: "jsx-b8a2230a7dc7ead2",
                                        children: "We will only use your (optional) phone number to contact you about this request, and will never share it."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                        className: "jsx-b8a2230a7dc7ead2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-b8a2230a7dc7ead2" + " " + "title",
                                                children: "How can we help?"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                                                name: "description",
                                                placeholder: "Message",
                                                className: "jsx-b8a2230a7dc7ead2"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            padding: "8px 0",
                                            textAlign: "right"
                                        },
                                        className: "jsx-b8a2230a7dc7ead2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            type: "submit",
                                            name: "submit",
                                            className: "jsx-b8a2230a7dc7ead2",
                                            children: "Request a demo"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        style: {
                                            marginBottom: 0
                                        },
                                        className: "jsx-b8a2230a7dc7ead2",
                                        children: [
                                            "By requesting a demo you agree to Watershed\u2019s",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/privacy",
                                                children: "privacy policy"
                                            }),
                                            ", and consent to receive Watershed marketing communications."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "b8a2230a7dc7ead2",
                children: '.grid.jsx-b8a2230a7dc7ead2{display:grid;grid-template-columns:4fr 3fr;-webkit-column-gap:24px;-moz-column-gap:24px;column-gap:24px}.left-col.jsx-b8a2230a7dc7ead2{border:2px solid#edf1f5;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;padding:48px}.right-col.jsx-b8a2230a7dc7ead2{-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;background:#f0f3f7;padding:32px}.right-col.jsx-b8a2230a7dc7ead2 .mobile-title.jsx-b8a2230a7dc7ead2{display:none;padding:0 16px}p.intro.jsx-b8a2230a7dc7ead2{font-size:21px;line-height:32px}form.jsx-b8a2230a7dc7ead2{display:grid;grid-gap:16px}form.jsx-b8a2230a7dc7ead2 p.jsx-b8a2230a7dc7ead2{font-size:14px;padding:0 16px}label.jsx-b8a2230a7dc7ead2{display:block;margin:0}label.jsx-b8a2230a7dc7ead2 .title.jsx-b8a2230a7dc7ead2{font-weight:bold;color:#222c49;margin:0 16px 4px}label.jsx-b8a2230a7dc7ead2 .title.required.jsx-b8a2230a7dc7ead2::after{content:"*";margin-left:4px;font-weight:regular;color:#ff8d73}input.jsx-b8a2230a7dc7ead2,textarea.jsx-b8a2230a7dc7ead2{padding:10px 16px;border:none;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px;background-color:#e3e7ee;font:inherit;font-size:16px;display:block;width:100%;margin-bottom:4px}input.jsx-b8a2230a7dc7ead2:focus,textarea.jsx-b8a2230a7dc7ead2:focus{outline:none;-webkit-box-shadow:0 0 0 2px inset#255dff;-moz-box-shadow:0 0 0 2px inset#255dff;box-shadow:0 0 0 2px inset#255dff}textarea.jsx-b8a2230a7dc7ead2{height:120px}button.jsx-b8a2230a7dc7ead2{cursor:pointer;padding:0 16px;height:32px;border:0;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;font-family:inherit;font-weight:bold;font-size:15px;background:#265cff;color:#fff;display:inline-block}button.jsx-b8a2230a7dc7ead2:focus{outline:none;-webkit-box-shadow:0 0 0 2px inset#001f79;-moz-box-shadow:0 0 0 2px inset#001f79;box-shadow:0 0 0 2px inset#001f79}button.jsx-b8a2230a7dc7ead2:disabled{cursor:default;opacity:.5}.customer-logos.jsx-b8a2230a7dc7ead2{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:32px;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.customer-logos.jsx-b8a2230a7dc7ead2>span{overflow:visible!important}.customer-logos.jsx-b8a2230a7dc7ead2 img{-webkit-transform-origin:left center;-moz-transform-origin:left center;-ms-transform-origin:left center;-o-transform-origin:left center;transform-origin:left center;-o-object-fit:contain;object-fit:contain}@media screen and (max-width:900px){.grid.jsx-b8a2230a7dc7ead2{grid-template-columns:1fr}.left-col.jsx-b8a2230a7dc7ead2{display:none}.right-col.jsx-b8a2230a7dc7ead2{padding:24px}.right-col.jsx-b8a2230a7dc7ead2 .mobile-title.jsx-b8a2230a7dc7ead2{display:block}}@media screen and (min-width:520px){label.jsx-b8a2230a7dc7ead2,form.jsx-b8a2230a7dc7ead2 div.jsx-b8a2230a7dc7ead2,form.jsx-b8a2230a7dc7ead2 p.jsx-b8a2230a7dc7ead2{grid-column:span 2}label.jsx-b8a2230a7dc7ead2:first-of-type,label.jsx-b8a2230a7dc7ead2:nth-of-type(2){grid-column:span 1}form.jsx-b8a2230a7dc7ead2{grid-template-columns:repeat(2,1fr)}}'
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_footer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Demo);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [109,89,854,774,888,179], function() { return __webpack_exec__(7608); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);